export const properties=()=>{
        return  {
          COTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-pro.appspot.com/COTIZA_RETIRO",
                    RECOTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-pro.appspot.com/RECOTIZA_RETIRO",
                    API_KEY:"AIzaSyBxt1g4td8AG1jOq44Dw9YwUC0qs52SsII"
                };
    }
    
    //QA
    /*
     COTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-qa.appspot.com/COTIZA_RETIRO",
                    RECOTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-qa.appspot.com/RECOTIZA_RETIRO",
                    API_KEY:"AIzaSyAICC9dWZWp1KmNqbvmWU8f9aIF7b0IS2Q"
    //UAT
    
     COTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-uat.appspot.com/COTIZA_RETIRO",
                    RECOTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-uat.appspot.com/RECOTIZA_RETIRO",
                    API_KEY:"AIzaSyBPyt1ed9ktULpWvKH6SqrWHZSEvBTbesk"
    //PRO
    
     COTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-pro.appspot.com/COTIZA_RETIRO",
                    RECOTIZA_RETIRO: "https://api-dot-gnp-portalcorporativo-pro.appspot.com/RECOTIZA_RETIRO",
                    API_KEY:"AIzaSyBxt1g4td8AG1jOq44Dw9YwUC0qs52SsII"
    */


// WEBPACK FOOTER //
// ./src/properties/properties.js